import debounce from "lodash/debounce";

const DEBOUNCE_TIME = 750;
const DEFAULT_SEARCH_KEY = "search";

export const findFiltersAndMapThemToKeyValuePairs  = (references) => {
    let filters = [];

    // ATTENTION: works with the reference of the "$slots" object
    // find deepest children with searchKey and make a filter out of it
    while (references.length >= 1) {
        const referenceOfcurrentSlot = references.shift();

        if (isHidden(referenceOfcurrentSlot)) { continue }

        const referenceSearchKey = referenceOfcurrentSlot?.data?.attrs?.searchKey
        if (referenceOfcurrentSlot?.data?.attrs?.searchKey != undefined) {
            const referenceLabel = referenceOfcurrentSlot?.data?.attrs?.filterPickerLabel ?? referenceOfcurrentSlot?.componentOptions?.propsData?.label;
            filters.push({ label: referenceLabel, searchKey: referenceSearchKey })
        } else if (referenceOfcurrentSlot?.children?.length > 0) {
            references.push(...referenceOfcurrentSlot.children);
        }
    }

    return filters;
}

export const findFiltersAndMakeThemToReactiveFilters = (references, model, emit) => {
    let filters = [];

    // ATTENTION: works with the reference of the "$slots" object
    // find deepest children with searchKey and make a filter out of it
    while (references.length >= 1) {
        const referenceOfcurrentSlot = references.shift();
        if (isHidden(referenceOfcurrentSlot)) { continue }

        const referenceSearchKey = referenceOfcurrentSlot?.data?.attrs?.searchKey;
        const referenceSkipFilterFlag = referenceOfcurrentSlot?.data?.attrs?.skipFilter;
        if (referenceSearchKey != undefined && (referenceSkipFilterFlag == undefined || referenceSkipFilterFlag === false)) {
            makeSlotToReactiveFilter(referenceOfcurrentSlot, model, emit);

            const referenceLabel = referenceOfcurrentSlot?.componentOptions?.propsData?.label;
            filters.push({ label: referenceLabel, searchKey: referenceSearchKey })
        } else if (referenceOfcurrentSlot?.children?.length > 0) {
            references.push(...referenceOfcurrentSlot.children);
        } else if (referenceOfcurrentSlot?.componentOptions?.children?.length > 0) {
            references.push(...referenceOfcurrentSlot.componentOptions.children);
        }
    }

    return filters;
}

const makeSlotToReactiveFilter = (referenceOfcurrentSlot, model, emit) => {
    const modelEvent = referenceOfcurrentSlot.componentOptions?.Ctor.options.model?.event || 'input';
    const modelProp = referenceOfcurrentSlot.componentOptions?.Ctor.options.model?.prop || 'value';
    const key = referenceOfcurrentSlot.data.attrs.searchKey;
    const isTextFilter = referenceOfcurrentSlot.data.attrs.isTextFilter;
    const isSearchFilter = key === DEFAULT_SEARCH_KEY;
    
    if (!referenceOfcurrentSlot.componentOptions.propsData) {
        referenceOfcurrentSlot.componentOptions.propsData = {};
    }

    if (!referenceOfcurrentSlot.componentOptions.listeners) {
        referenceOfcurrentSlot.componentOptions.listeners = {};
    }

    let debounceTime = (isTextFilter || isSearchFilter) ? DEBOUNCE_TIME : referenceOfcurrentSlot?.data?.attrs?.debounce;

    let filterInputEvent = (event) => {
        // allows to trigger different filters
        if (event != undefined && typeof event === 'object' && event.preventDefault === true) {
            return emit(event.searchKeyOverride, event.value)
        }
        if (isTextFilter && event == ""){
            return emit(key, undefined)
        }

        if (referenceOfcurrentSlot.componentInstance?.isFilter && event === false) {
            return emit(key, undefined)
        }

        emit(key, event)
    }

    // will hand over whole filter state, not dependent one
    if (referenceOfcurrentSlot.data.attrs['value-is-filter-state']) {
        referenceOfcurrentSlot.componentOptions.propsData[modelProp] = model;
    } else {
        referenceOfcurrentSlot.componentOptions.propsData[modelProp] = model[key];
    }

    referenceOfcurrentSlot.componentOptions.listeners[modelEvent] = debounceTime ? debounce(filterInputEvent, debounceTime) : filterInputEvent;
}

export const isHidden = (vNode) => {
    return vNode?.tag == undefined
}
